import { render, staticRenderFns } from "./PeopleAndGroupsTemplate.vue?vue&type=template&id=e5d3e200&scoped=true"
import script from "./PeopleAndGroupsTemplate.vue?vue&type=script&lang=js"
export * from "./PeopleAndGroupsTemplate.vue?vue&type=script&lang=js"
import style0 from "./PeopleAndGroupsTemplate.vue?vue&type=style&index=0&id=e5d3e200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d3e200",
  null
  
)

export default component.exports